package com.daytimegaming.ourdailyfinances.data.network.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RealEstateValueEstimateDto(
    @SerialName("date") val date: String,
    @SerialName("estimated_value") val estimatedValue: Double,
    @SerialName("price_range_low") val priceRangeLow: Double? = null,
    @SerialName("price_range_high") val priceRangeHigh: Double? = null,
)

@Serializable
data class RealEstateHoldingDto(
    @SerialName("real_estate_holding_id") val realEstateHoldingId: String,
    @SerialName("user_id") val userId: String? = null,
    @SerialName("nickname") val nickname: String,
    @SerialName("address_line_1") val addressLine1: String,
    @SerialName("address_line_2") val addressLine2: String? = null,
    @SerialName("city") val city: String,
    @SerialName("state") val state: String,
    @SerialName("zip_code") val zipCode: String,
    @SerialName("county") val county: String? = null,
    @SerialName("purchase_price") val purchasePrice: Double,
    @SerialName("mortgage_amount") val mortgageAmount: Double? = null,
    @SerialName("mortgage_interest_rate") val mortgageInterestRate: Double? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("added_by_user_id") val addedByUserId: String? = null,
    @SerialName("value_estimates") val valueEstimates: List<RealEstateValueEstimateDto> = emptyList(),
)

@Serializable
data class RealEstateHoldingListResponse(
    @SerialName("real_estate_holdings") val holdings: List<RealEstateHoldingDto>,
)

@Serializable
data class CreateRealEstateHoldingRequest(
    @SerialName("nickname") val nickname: String,
    @SerialName("address_line_1") val addressLine1: String,
    @SerialName("address_line_2") val addressLine2: String? = null,
    @SerialName("city") val city: String,
    @SerialName("state") val state: String,
    @SerialName("zip_code") val zipCode: String,
    @SerialName("county") val county: String? = null,
    @SerialName("purchase_price") val purchasePrice: Double,
    @SerialName("mortgage_amount") val mortgageAmount: Double? = null,
    @SerialName("mortgage_interest_rate") val mortgageInterestRate: Double? = null,
)

@Serializable
data class UpdateRealEstateHoldingRequest(
    @SerialName("nickname") val nickname: String? = null,
    @SerialName("address_line_1") val addressLine1: String? = null,
    @SerialName("address_line_2") val addressLine2: String? = null,
    @SerialName("city") val city: String? = null,
    @SerialName("state") val state: String? = null,
    @SerialName("zip_code") val zipCode: String? = null,
    @SerialName("county") val county: String? = null,
    @SerialName("purchase_price") val purchasePrice: Double? = null,
    @SerialName("mortgage_amount") val mortgageAmount: Double? = null,
    @SerialName("mortgage_interest_rate") val mortgageInterestRate: Double? = null,
)

@Serializable
data class AssociateRealEstateHoldingRequest(
    @SerialName("real_estate_holding_id") val realEstateHoldingId: String,
)
